import React from 'react';
import glamorous from 'glamorous';
import PropTypes from 'prop-types';
import {WHITE, CONCRETE, ASH} from '../../../../shared/style/colors';
import {PHONE_LANDSCAPE} from '../../../../shared/style/breakpoints';

const ItemContainer = glamorous.div({
  display: 'inline-flex',
  flex: 1,
  alignItems: 'center',
  borderRadius: 2,
  border: `solid 1px ${ASH}`,
  backgroundColor: WHITE,
  padding: 6,
  [PHONE_LANDSCAPE]: {
    marginTop: 10,
    marginBottom: 10,
    marginLeft: 0,
    marginRight: 0
  }
});

const RemoveTextContainer = glamorous.div({
  backgroundColor: CONCRETE,
  borderRadius: '50%',
  width: 17,
  height: 17,
  lineHeight: '17px',
  textAlign: 'center',
  fontSize: 15,
  color: WHITE,
  cursor: 'pointer',
  ':hover': {
    backgroundColor: ASH
  }
});

export default function ComparisonItem(props) {
  const {children, onRemoveClick, ...restProps} = props;

  return (
    <ItemContainer {...restProps}>
      {children}
      {onRemoveClick && <RemoveTextContainer onClick={onRemoveClick}>&times;</RemoveTextContainer>}
    </ItemContainer>
  );
}

ComparisonItem.propTypes = {
  onRemoveClick: PropTypes.func,
  children: PropTypes.node.isRequired
};
